<template>
  <v-container fill-height fluid style="padding: 0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-stepper v-model="stepper" class="fill-height" id="stepper">
          <v-stepper-header id="stepper_header" :style="{top: stepperTopPosition}">
            <v-stepper-step complete-icon="location_on" edit-icon="location_on" :complete="stepper > 1" :step="1" editable>
              {{ Paso1 }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step complete-icon="format_list_numbered" edit-icon="format_list_numbered" :complete="mostrarTodos" :step="2" :editable="mostrarTodos">
              {{ Paso2 }}
            </v-stepper-step>
            <v-divider v-show="mostrarTodos"></v-divider>
            <v-stepper-step complete-icon="bar_chart" edit-icon="bar_chart" complete editable :step="3" v-show="mostrarTodos">
              {{ Paso3 }}
            </v-stepper-step>
            <v-divider v-show="mostrarTodos"></v-divider>
            <v-stepper-step complete-icon="bar_chart" edit-icon="bar_chart" complete editable :step="4" v-show="mostrarTodos">
              {{ Paso4 }}
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content :step="1">
              <v-layout row wrap>
                <v-flex xs12>
                  <div id="mapaArgentina">
                    <map-arg></map-arg>
                  </div>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content :step="2">
              <v-card class="mb-3">
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">Calculador Solar</h3>
                  </div>
                </v-card-title>
                <v-form v-model="valid" ref="form" lazy-validation v-if="provinciaSeleccionada">
                  <v-layout row wrap>
                    <v-flex sm12 md6 class="pl-3 pr-3">
                      <v-text-field label="Provincia Seleccionada" readonly v-model="provinciaSeleccionadaNombre" background-color="white" type="text"></v-text-field>
                    </v-flex>
                    <v-flex sm12 md6 class="pl-3 pr-3">
                      <v-text-field label="Tarifa" ref="inputTarifa" placeholder="(Valor del Cargo Variable)" v-model.number="form.tarifa" background-color="white" type="number" suffix="$/kWh" v-validate="'required|min_value:1'" name="Tarifa" :error-messages="errors.collect('Tarifa')">
                        <v-menu v-model="menuCargoVariable" :close-on-content-click="false" :nudge-width="200" offset-x slot="append" class="no-print">
                          <v-btn flat small icon color="primary" slot="activator" style="margin:0;" @click.stop="isModalVisibleCargoVariable=true">
                            <v-icon>info</v-icon>
                          </v-btn>
                          <modal :visible="isModalVisibleCargoVariable" @close="isModalVisibleCargoVariable=false">
                            <template slot="header">
                              <h3>Valor de Cargo Variable</h3>
                            </template>
                            <template slot="body">
                              <p>
                                Busque el detalle del Cargo Variable
                                <strong>[$/kWh]</strong> en su factura.
                                <strong>(Valor entre 0 y 10 $/kWh)</strong>
                              </p>
                              <p>Ejemplo:</p>
                              <p>Cargo Variable:
                                <span class="red--text">$ 0,9080/kWh</span>
                              </p>
                              <v-card-media :src="''+require('@/assets/img/tarifa.png')" height="200px" contain></v-card-media>
                              <p>
                                Si no figura el Cargo Variable en su factura, remítase al Cuadro Tarifario de su
                                <strong>distribuidora de electricidad.</strong>
                              </p>
                            </template>
                          </modal>
                        </v-menu>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 class="pl-3 pr-3 text-xs-center" v-show="mostrarSiguiente">
                      <v-btn color="primary" :disabled="this.form.tarifa == null" @click="manualForm">Siguiente</v-btn>
                    </v-flex>
                    <v-flex xs12 class="pl-3 pr-3 text-xs-center no-print" align-center v-show="primeraVez">
                      <v-btn color="primary" @click="autoCompletarForm">Autocompletar</v-btn>
                      <small style="display: block;">(Valores Promedios para Residenciales)</small>
                    </v-flex>
                    <v-flex sm6 md6 class="pl-3 pr-3" v-show="primeraVez && mismoConsumo">
                      <v-text-field ref="inputConsumoMensual" label="Consumo mensual" v-model.number="consumo" background-color="white" type="number" suffix="kWh/mes" name="Consumo" v-validate="consumoRule" :error-messages="errors.collect('Consumo')">
                        <v-menu v-model="menuConsumo" :close-on-content-click="false" :nudge-width="200" offset-x slot="append" class="no-print">
                          <v-btn flat small icon color="primary" slot="activator" style="margin:0;" @click.stop="isModalVisibleConsumo=true">
                            <v-icon>info</v-icon>
                          </v-btn>
                          <modal :visible="isModalVisibleConsumo" @close="isModalVisibleConsumo=false">
                            <template slot="header">
                              <h3>Consumo Mensual</h3>
                            </template>
                            <template slot="body">
                              <p>En su Factura Eléctrica busque el consumo elétrico Mensual [kWh/mes].</p>
                              <p>Ejemplo:</p>
                              <v-card-media :src="''+require('@/assets/img/consumo.jpg')" height="200px" contain></v-card-media>
                              <p>
                                Si su registro es bimestral, divida por 2 para obtener el consumo mensual.
                              </p>
                              <p>
                                Si usted no completa algún consumo mensual, se utilizará el promedio anual.
                              </p>
                            </template>
                          </modal>
                        </v-menu>
                      </v-text-field>
                    </v-flex>
                    <v-flex sm6 md6 class="pl-3 pr-3 no-print" v-show="primeraVez">
                      <v-checkbox label="Mismo consumo para todos los meses" v-model="mismoConsumo"></v-checkbox>
                    </v-flex>
                    <v-layout row wrap v-show="!mismoConsumo && primeraVez">
                      <v-flex xs12 class="pl-3 pr-3 no-print">
                        <small :class="{'error--text': !mismoConsumo && errors.has('Enero')}">Debe completar al menos un mes</small>
                      </v-flex>
                      <v-flex xs6 sm4 md3 class="pl-3 pr-3" v-for="mes in meses" :key="mes">
                        <v-text-field v-model.number="form.consumos[mes.toLowerCase()]" background-color="white" type="number" :label="mes" v-validate="mesRule" :name="mes"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-flex sm6 class="pl-3 pr-3" v-show="primeraVez">
                      <v-text-field label="Potencia del panel" v-model.number="form.potenciaPanel" background-color="white" type="number" suffix="W" v-validate="'required|min_value:1'" name="Potencia" :error-messages="errors.collect('Potencia')">
                        <v-menu v-model="menuPotencia" :close-on-content-click="false" :nudge-width="200" offset-x slot="append" class="no-print">
                          <v-btn flat small icon color="primary" slot="activator" style="margin:0;" @click.stop="isModalVisiblePotencia=true">
                            <v-icon>info</v-icon>
                          </v-btn>
                          <modal :visible="isModalVisiblePotencia" @close="isModalVisiblePotencia=false">
                            <template slot="header">
                              <h3>Potencia del panel</h3>
                            </template>
                            <template slot="body">
                              <p>En general, los paneles solares para conexión a red, rondan entre los
                                <strong>230 Watt y 330 Watt [W]</strong>, esta información se encuentra detallada en la parte trasera del panel solar.</p>
                            </template>
                          </modal>
                        </v-menu>
                      </v-text-field>
                    </v-flex>
                    <v-flex sm6 class="pl-3 pr-3" v-show="primeraVez">
                      <v-text-field label="Cantidad de paneles" v-model.number="form.paneles" background-color="white" type="number" v-validate="'required|min_value:1'" name="Paneles" :error-messages="errors.collect('Paneles')">
                        <v-menu v-model="menuPaneles" :close-on-content-click="false" :nudge-width="200" offset-x slot="append" class="no-print">
                          <v-btn flat small icon color="primary" slot="activator" style="margin:0;" @click.stop="isModalVisiblePaneles=true">
                            <v-icon>info</v-icon>
                          </v-btn>
                          <modal :visible="isModalVisiblePaneles" @close="isModalVisiblePaneles=false">
                            <template slot="header">
                              <h3>Cantidad de Paneles</h3>
                            </template>
                            <template slot="body">
                              <p>Un panel solar ocupa aproximadamente la superficie de una puerta (2 m
                                <sup>2</sup>), tenga en cuenta la superficie que dispone.</p>
                            </template>
                          </modal>
                        </v-menu>
                      </v-text-field>
                    </v-flex>
                    <v-flex sm6 class="pl-3 pr-3" v-show="primeraVez">
                      <v-text-field label="Superficie" v-model.number="superficie" background-color="white" type="number" suffix="m2" disabled></v-text-field>
                    </v-flex>
                    <v-flex sm6 class="pl-3 pr-3" v-show="primeraVez">
                      <v-text-field label="Potencia a instalar" v-model.number="potenciaInstalar" background-color="white" type="number" suffix="kW" disabled></v-text-field>
                    </v-flex>
                    <v-flex sm12 md6 class="pl-3 pr-3" v-show="primeraVez">
                      <v-text-field label="Autoconsumo" v-model.number="form.autoconsumo" background-color="white" type="number" suffix="%" v-validate="'required|min_value:1'" name="Autoconsumo" :error-messages="errors.collect('Autoconsumo')">
                        <v-menu v-model="menuAutoconsumo" :close-on-content-click="false" :nudge-width="200" offset-x slot="append" class="no-print">
                          <v-btn flat small icon color="primary" slot="activator" style="margin:0;" @click.stop="isModalVisibleAutoconsumo=true">
                            <v-icon>info</v-icon>
                          </v-btn>
                          <modal :visible="isModalVisibleAutoconsumo" @close="isModalVisibleAutoconsumo=false">
                            <template slot="header">
                              <h3>Autoconsumo</h3>
                            </template>
                            <template slot="body">
                              <table class="v-datatable v-table">
                                <thead>
                                  <tr>
                                    <th class='column white--text lighten-2 light-blue'>DESCRIPCIÓN</th>
                                    <th class='column white--text lighten-2 light-blue'>AUTOCONSUMO</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class="text-xs-center">Residenciales</td>
                                    <td class="text-xs-center">
                                      <strong>30% / 40%</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-xs-center">Comerciales</td>
                                    <td class="text-xs-center">
                                      <strong>50% / 60%</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-xs-center">Industriales</td>
                                    <td class="text-xs-center">
                                      <strong>60% / 70%</strong>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p class="mt-2">Es la fracción de energía que efectivamente es consumida dentro de su hogar, comercio o industria, respecto al total de la energía que generan los paneles solares conectados. Dado que los paneles solares generan energía eléctrica durante las horas de sol, si Ud. se encuentra consumiendo energía dentro del hogar, comercio o industria durante el día, mayor será el porcentaje de Autoconsumo.</p>
                              <p><strong>La Inyección: </strong>En caso de existir energía restante que no fue autoconsumida (excedentes), la misma será inyectada y vendida al distribuidor.</p>
                            </template>
                          </modal>
                        </v-menu>
                      </v-text-field>
                    </v-flex>
                    <v-flex sm12 md6 hidden-sm-and-down class="pl-3 pr-3 no-print" v-show="primeraVez"></v-flex>
                    <v-flex sm12 md6 class="pl-3 pr-3" v-show="primeraVez">
                      <v-select style="float: left; width: calc(100% - 30px)" :items="elementosOrientacion" v-model="form.acimut" label="Orientación del panel (Acimut α)" v-validate="'required|min_value:0'" name="Orientacion" data-vv-as="Orientación" :error-messages="errors.collect('Orientacion')" @change="validateSelectOrientacion"></v-select>
                      <v-menu style="padding-top: 20px" v-model="menuOrientacion" :close-on-content-click="false" :nudge-width="200" offset-x class="no-print">
                        <v-btn flat small icon color="primary" slot="activator" style="margin:0;" @click.stop="isModalVisibleOrientacion=true">
                          <v-icon>info</v-icon>
                        </v-btn>
                        <modal :visible="isModalVisibleOrientacion" @close="isModalVisibleOrientacion=false">
                          <template slot="header">
                            <h3>Orientación del Panel</h3>
                          </template>
                          <template slot="body">
                            <p>El Acimut (α), es el ángulo de desviación respecto del norte geográfico.</p>
                            <v-card-media :src="''+require('@/assets/img/acimut.gif')" height="400px" contain></v-card-media>
                          </template>
                        </modal>
                      </v-menu>
                    </v-flex>
                    <v-flex sm12 md6 hidden-sm-and-down class="pl-3 pr-3 no-print" v-show="primeraVez"></v-flex>
                    <v-flex sm12 md6 class="pl-3 pr-3" v-show="primeraVez">
                      <v-select style="float: left; width: calc(100% - 30px)" :items="elementosInclinacion" v-model="form.inclinacion" label="Inclinación del panel (β)" v-validate="'required|min_value:0'" name="Inclinacion" data-vv-as="Inclinación" :error-messages="errors.collect('Inclinacion')" @change="validateSelectInclinacion"></v-select>
                      <v-menu style="padding-top: 20px" v-model="menuInclinacion" :close-on-content-click="false" :nudge-width="200" offset-x class="no-print">
                        <v-btn flat small icon color="primary" slot="activator" style="margin:0;" @click.stop="isModalVisibleInclinacion=true">
                          <v-icon>info</v-icon>
                        </v-btn>
                        <modal :visible="isModalVisibleInclinacion" @close="isModalVisibleInclinacion=false">
                          <template slot="header">
                            <h3>Inclinación del Panel</h3>
                          </template>
                          <template slot="body">
                            <p>La Inclinación (β), es el ángulo que se forma respecto de la horizontal.</p>
                            <v-card-media :src="''+require('@/assets/img/inclinacion.gif')" height="300px" contain></v-card-media>
                          </template>
                        </modal>
                      </v-menu>
                    </v-flex>
                    <v-flex sm12 md6 class="pl-3 pr-3 no-print" v-show="primeraVez">
                      <div>
                        <label>
                          Elija el mejor ángulo:
                          <v-menu v-model="menuAngulo" :close-on-content-click="false" :nudge-width="200" offset-x class="no-print">
                            <v-btn flat small icon color="primary" slot="activator" style="margin:0;" @click.stop="isModalVisibleAngulo=true">
                              <v-icon>info</v-icon>
                            </v-btn>
                            <modal :visible="isModalVisibleAngulo" @close="isModalVisibleAngulo=false">
                              <template slot="header">
                                <h3>Ángulos Óptimos</h3>
                              </template>
                              <template slot="body">
                                <p>Los ángulos de orientación e inclinación óptimos, son aquellos donde la generación de energía anual es la máxima, según la Latitud y Longitud de la provincia elegida. (Lat:27.46 ; Lon:64.18)</p>
                              </template>
                            </modal>
                          </v-menu>
                        </label>
                      </div>
                      <v-btn color="primary" @click="optimizarAngulos">Optimizar Ángulos</v-btn>
                    </v-flex>
                    <v-flex xs12 v-show="primeraVez" class="mt-4 no-print">
                      <v-btn id="btnCalcular" color="success" block @click="submit" :disabled="!valid">
                        Calcular
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card>
            </v-stepper-content>
            <v-stepper-content :step="3">
              <v-layout row wrap>
                <v-flex xs12>
                  <grafico1 :volar=false></grafico1>
                  <grafico1 :volar=true></grafico1>
                </v-flex>
                <v-flex sm6>
                  <hr class="no-print">
                  <table class="v-datatable v-table mt-1">
                    <tbody>
                      <tr>
                        <td class="text-xs-center"><strong>Consumo de la Red sin Paneles Solares</strong></td>
                        <td class="text-xs-center">{{consumoAnualSinPaneles}}</td>
                        <td class="text-xs-center">[kWh/año]</td>
                      </tr>
                      <tr>
                        <td class="text-xs-center"><strong>Generación total anual (Paneles Solares)</strong></td>
                        <td class="text-xs-center">{{generacionAnualPaneles === null ? '' : generacionAnualPaneles.toFixed(0)}}</td>
                        <td class="text-xs-center">[kWh/año]</td>
                      </tr>
                      <tr>
                        <td class="text-xs-center"><strong>Ahorro por Autoconsumo anual</strong></td>
                        <td class="text-xs-center">{{ahorroAnualAutoconsumo === null ? '' : ahorroAnualAutoconsumo.toFixed(0)}}</td>
                        <td class="text-xs-center">[kWh/año]</td>
                      </tr>
                      <tr>
                        <td class="text-xs-center"><strong>Ahorro por Autoconsumo porcentual anual</strong></td>
                        <td class="text-xs-center">{{ahorroAnualAutoconsumoPorcentaje}}%</td>
                        <td class="text-xs-center">[%]</td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
                <v-flex sm6 xs12 class="text-xs-center" id="ahorro_emisiones">
                  <hr class="no-print">
                  <p class="headline mt-4">Ahorro de Emisiones de Gases de Efecto Invernadero</p>
                  <div class="display-3 font-weight-bold">
                    <p class="green--text">{{emisiones}}</p>
                  </div>
                  <small style="font-size:18px">Toneladas de CO
                    <sub>2</sub> equivalentes</small>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content :step="4">
              <v-layout row wrap>
                <v-flex xs12>
                  <grafico2 :volar=false></grafico2>
                  <grafico2 :volar=true></grafico2>
                </v-flex>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
    <v-speed-dial v-show="printAvailable" v-model="print" fixed bottom right direction="top" transition="scale-transition">
      <v-btn slot="activator" v-model="print" color="primary" dark fab hover>
        <v-icon>print</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-btn fab dark small color="primary" @click="imprimirPDF">
        <v-icon>print</v-icon>
      </v-btn>
      <v-btn fab dark small color="primary" @click="descargarPDF">
        <v-icon>cloud_download</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-snackbar v-model="printSnackbar" bottom right>
      Ya puede imprimir
      <v-btn dark flat @click="printSnackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import mapArg from '@/assets/mapa-argentina.svg'
import axios from 'axios'
import { REST_API_PROVINCIAS, REST_API_CALCULAR_AHORRO } from '@/utils/const.js'
import veeEs from 'vee-validate/dist/locale/es'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

export default {
  name: 'calculadorSolar',
  components: {
    mapArg,
    Grafico1: () => import('@/components/Grafico1'),
    Grafico2: () => import('@/components/Grafico2'),
    Modal: () => import('@/components/Modal')
  },
  data() {
    return {
      scrollPosition: 0,
      stepperTopPosition:
        document.getElementsByTagName('nav')[0].getBoundingClientRect().height +
        'px',
      print: false,
      isModalVisibleCargoVariable: false,
      isModalVisibleConsumo: false,
      isModalVisiblePotencia: false,
      isModalVisiblePaneles: false,
      isModalVisibleAutoconsumo: false,
      isModalVisibleOrientacion: false,
      isModalVisibleInclinacion: false,
      isModalVisibleAngulo: false,
      menuCargoVariable: false,
      menuConsumo: false,
      menuPotencia: false,
      menuPaneles: false,
      menuAutoconsumo: false,
      menuOrientacion: false,
      menuInclinacion: false,
      menuAngulo: false,
      Paso1: 'Elija una Provincia',
      Paso2: 'Complete el Formulario',
      Paso3: 'Gráfico 1',
      Paso4: 'Gráfico 2',
      Paso5: 'Ahorro de Emisiones',
      stepper: 1,
      provincias: [],
      provinciaSeleccionada: null,
      provinciaSeleccionadaNombre: null,
      valid: true,
      primeraVez: false,
      meses: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ],
      elementosOrientacion: ['0', '15', '30', '45', '60'],
      elementosInclinacion: [
        '0',
        '5',
        '10',
        '15',
        '20',
        '25',
        '30',
        '35',
        '40',
        '45',
        '50',
        '55',
        '60',
        '65',
        '70',
        '75',
        '80',
        '85',
        '90'
      ],
      mismoConsumo: false,
      consumo: null,
      errorMeses: false,
      form: {
        idProvincia: null,
        tarifa: null,
        consumos: {
          enero: null,
          febrero: null,
          marzo: null,
          abril: null,
          mayo: null,
          junio: null,
          julio: null,
          agosto: null,
          septiembre: null,
          octubre: null,
          noviembre: null,
          diciembre: null
        },
        potenciaPanel: null,
        paneles: null,
        autoconsumo: null,
        acimut: null,
        inclinacion: null
      },
      mostrarTodos: false,
      mostrarSiguiente: true,
      printSnackbar: false,
      printAvailable: false
    }
  },
  computed: {
    consumoRule() {
      return this.mismoConsumo ? 'required|min_value:1' : ''
    },
    mesRule() {
      let required = true

      if (Object.keys(this.form.consumos).some(this.testMes)) {
        required = false
      }
      return required ? 'required|min_value:1' : ''
    },
    superficie() {
      let sup
      if (this.form.paneles != null) {
        sup = Number((this.form.paneles * 1.65).toFixed(1).replace(',', '.'))
      } else {
        sup = null
      }
      return sup
    },
    potenciaInstalar() {
      let pot
      if (this.form.paneles != null && this.form.potenciaPanel != null) {
        pot = Number(
          ((this.form.paneles * this.form.potenciaPanel) / 1000)
            .toFixed(1)
            .replace(',', '.')
        )
      } else {
        pot = null
      }
      return pot
    },
    emisiones() {
      if (this.$store.getters.currentData != null) {
        return this.$store.getters.currentData.variacionFacturacion
          .totalesAnuales.emisionesGEI
      } else {
        return '---'
      }
    },
    consumoAnualSinPaneles() {
      if (this.$store.getters.currentData != null) {
        return this.$store.getters.currentData.variacionFacturacion.seriesMensuales.consumoRedSinFV.reduce(
          (a, b) => a + b,
          0
        )
      } else {
        return null
      }
    },
    generacionAnualPaneles() {
      if (this.$store.getters.currentData != null) {
        return this.$store.getters.currentData.variacionFacturacion
          .totalesAnuales.generacionAnualPanel
      } else {
        return null
      }
    },
    ahorroAnualAutoconsumo() {
      if (this.$store.getters.currentData != null) {
        return this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida.reduce(
          function(valorAnterior, valorActual, indice, vector) {
            return valorAnterior + valorActual
          }
        )
      } else {
        return null
      }
    },
    ahorroAnualAutoconsumoPorcentaje() {
      if (this.$store.getters.currentData != null) {
        return (
          (this.ahorroAnualAutoconsumo / this.consumoAnualSinPaneles) *
          100
        ).toFixed(1)
      } else {
        return null
      }
    }
  },
  watch: {
    scrollPosition: function(valnew, valold) {
      if (valnew < valold) {
        this.stepperTopPosition =
          document.getElementsByTagName('nav')[0].getBoundingClientRect()
            .height + 'px'
      } else {
        this.stepperTopPosition = '0'
      }
    },
    primeraVez: function(valnew, valold) {
      if (valnew) {
        this.$nextTick(function() {
          this.$refs.inputConsumoMensual.focus()
        })
      }
    },
    provinciaSeleccionada: function(valnew, valold) {
      if (valold != null) {
        // reset paso 2
        this.Paso2 = 'Complete el Formulario'
        this.form.tarifa = null
        this.primeraVez = false
        this.mostrarTodos = false
        this.mostrarSiguiente = true
        this.$store.dispatch('obteniendoDatos')
        this.printAvailable = false
      }
    },
    consumo: function(valnew, valold) {
      if (this.mismoConsumo) {
        this.form.consumos.enero = valnew
        this.form.consumos.febrero = valnew
        this.form.consumos.marzo = valnew
        this.form.consumos.abril = valnew
        this.form.consumos.mayo = valnew
        this.form.consumos.junio = valnew
        this.form.consumos.julio = valnew
        this.form.consumos.agosto = valnew
        this.form.consumos.septiembre = valnew
        this.form.consumos.octubre = valnew
        this.form.consumos.noviembre = valnew
        this.form.consumos.diciembre = valnew
      }
    },
    stepper: function(valnew, valold) {
      if (valnew === 3 || valnew === 4) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.$validator.localize('es', veeEs)
    let provinciasMapa = document.querySelectorAll(
      '#mapaArgentina path:not(#caba-sample)'
    )
    provinciasMapa.forEach(provinciaMapa => {
      provinciaMapa.addEventListener('click', this.handleSVGClick)
    })
    axios
      .get(REST_API_PROVINCIAS)
      .then(response => {
        this.provincias = response.data
      })
      .catch(error => {
        // handle error
        alert(error)
      })
  },
  methods: {
    handleScroll() {
      this.scrollPosition = window.scrollY
    },
    handleSVGClick(e) {
      const provinciasMapa = document.querySelectorAll(
        '#mapaArgentina path:not(#caba-sample)'
      )
      provinciasMapa.forEach(element => {
        element.setAttribute('fill', '')
      })
      let provinciaID = e.target.getAttribute('id')
      e.target.setAttribute('fill', '#75c2e7')
      this.provinciaSeleccionada = this.provincias.filter(function(item) {
        // se usan los mismos datos de bsas para caba
        const prov = provinciaID === 'c-a-b-a' ? 'buenos-aires' : provinciaID
        return item.idParaMapa === prov
      })[0]
      if (provinciaID === 'c-a-b-a') {
        this.Paso1 = 'C.A.B.A'
        this.provinciaSeleccionadaNombre = 'Ciudad Autónoma de Buenos Aires'
      } else {
        this.Paso1 = this.provinciaSeleccionada.nombre
        this.provinciaSeleccionadaNombre = this.provinciaSeleccionada.nombre
      }
      this.form.idProvincia = this.provinciaSeleccionada.idProvincia
      this.stepper = 2
      setTimeout(() => {
        this.$refs.inputTarifa.focus()
      }, 500)
    },
    autoCompletarForm() {
      this.primeraVez = true
      this.Paso2 = 'Autocompletado'
      this.mismoConsumo = true
      this.consumo = 300
      this.form.potenciaPanel = 280
      this.form.paneles = 6
      this.form.autoconsumo = 40
      this.form.acimut = this.provinciaSeleccionada.acimutOptimo.toString()
      this.form.inclinacion = this.provinciaSeleccionada.incOptima.toString()
      setTimeout(() => {
        document
          .getElementById('btnCalcular')
          .scrollIntoView({ block: 'end', behavior: 'smooth' })
        this.$validator.validateAll()
      }, 200)
    },
    manualForm() {
      this.mostrarSiguiente = false
      this.Paso2 = 'Manual'
      this.mismoConsumo = true
      this.consumo = null
      this.form.potenciaPanel = null
      this.form.paneles = null
      this.form.autoconsumo = null
      this.form.acimut = null
      this.form.inclinacion = null
      this.$validator.reset()
      this.primeraVez = true
    },
    testMes(element) {
      return (
        this.form.consumos[element] !== null &&
        this.form.consumos[element] !== ''
      )
    },
    validateSelectOrientacion(val) {
      this.$validator.validate('Orientacion')
    },
    validateSelectInclinacion(val) {
      this.$validator.validate('Inclinacion')
    },
    optimizarAngulos() {
      this.form.acimut = '0'
      this.form.inclinacion = this.provinciaSeleccionada.incOptimaTabla.toString()
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('obteniendoDatos')
          let self = this
          axios
            .post(REST_API_CALCULAR_AHORRO, this.form)
            .then(function(response) {
              self.$store.dispatch('datosObtenidos', response.data)
              self.mostrarTodos = true
              self.stepper = 3
              self.printSnackbar = true
              self.printAvailable = true
            })
            .catch(function(error) {
              alert(error)
            })
        } else {
          document
            .querySelector('.error--text')
            .scrollIntoView({ block: 'end', behavior: 'smooth' })
        }
      })
    },
    imgtoDataURL(imageName, imageFormat) {
      return new Promise((resolve, reject) => {
        let img = new Image()
        img.setAttribute('src', require(`@/assets/img/${imageName}`))
        document.body.appendChild(img)
        img.onload = function() {
          var canvas = document.createElement('canvas')
          var context = canvas.getContext('2d')

          canvas.width = img.width
          canvas.height = img.height
          context.drawImage(img, 0, 0, img.width, img.height)
          let dataURL = canvas.toDataURL(`image/${imageFormat}`, 0.9)
          document.querySelector('body > img:last-of-type').remove()
          resolve(dataURL)
        }
      })
    },
    svgToImg(svg) {
      return new Promise((resolve, reject) => {
        let xml = new XMLSerializer().serializeToString(svg)
        let data =
          'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(xml)))
        let img = new Image()
        img.setAttribute('src', data)
        document.body.appendChild(img)
        img.onload = function() {
          var canvas = document.createElement('canvas')
          var context = canvas.getContext('2d')

          canvas.width = img.width
          canvas.height = img.height
          context.drawImage(img, 0, 0, img.width, img.height)
          let dataURL = canvas.toDataURL('image/jpeg')
          resolve(dataURL)
        }
      })
    },
    graficosToDataURI() {
      return new Promise((resolve, reject) => {
        let promiseGrafico1 = new Promise((resolve, reject) => {
          let svgGraficoElectricidad = document.querySelector(
            '#grafico_1.mandar-a-volar .highcharts-container'
          ).firstChild
          this.svgToImg(svgGraficoElectricidad).then(dataElec => {
            document.querySelector('body > img:last-of-type').remove()
            resolve(dataElec)
          })
        })

        let promiseGrafico2 = new Promise((resolve, reject) => {
          let svgGraficoGas = document.querySelector(
            '#grafico_2.mandar-a-volar .highcharts-container'
          ).firstChild
          this.svgToImg(svgGraficoGas).then(dataGas => {
            document.querySelector('body > img:last-of-type').remove()
            resolve(dataGas)
          })
        })

        Promise.all([promiseGrafico1, promiseGrafico2])
          .then(respuesta => {
            resolve(respuesta)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    imagenesToDataURI() {
      return new Promise((resolve, reject) => {
        let caratulaPromise = this.imgtoDataURL('caratula.jpg', 'JPEG')
        let contratapaPromise = this.imgtoDataURL('contratapa.jpg', 'JPEG')
        let inclinacionPromise = this.imgtoDataURL('inclinacion.jpg', 'JPEG')
        let orientacionPromise = this.imgtoDataURL('orientacion.jpg', 'JPEG')

        Promise.all([
          caratulaPromise,
          contratapaPromise,
          inclinacionPromise,
          orientacionPromise
        ])
          .then(respuesta => {
            resolve(respuesta)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    generarPDF() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.graficosToDataURI().then(graficos => {
            let grafico1 = graficos[0]
            let grafico2 = graficos[1]
            this.imagenesToDataURI().then(imagenesRespuesta => {
              let imagenCaratula = imagenesRespuesta[0]
              let imagenContratapa = imagenesRespuesta[1]
              let imagenInclinacion = imagenesRespuesta[2]
              let imagenOrientacion = imagenesRespuesta[3]

              let docDefinition = {
                pageSize: 'A4',
                background: function(currentPage) {
                  if (currentPage === 1) {
                    return { image: imagenCaratula, fit: [850, 850] }
                  } else if (currentPage === 7) {
                    return { image: imagenContratapa, fit: [850, 850] }
                  }
                },
                footer: function(currentPage, pageCount) {
                  if (currentPage !== 1 && currentPage !== 7) {
                    return {
                      text: `${(currentPage - 1).toString()} de ${pageCount -
                        2}`,
                      alignment: 'center'
                    }
                  } else {
                    return ''
                  }
                },
                styles: {
                  subtitulo: {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 20, 0, 5]
                  },
                  tableExample: {
                    margin: [0, 5, 0, 15]
                  },
                  titulo: {
                    bold: true,
                    fontSize: 18,
                    margin: [0, 0, 0, 10]
                  }
                },
                content: [
                  {
                    text: 'Reporte',
                    pageBreak: 'before',
                    style: 'titulo'
                  },
                  {
                    text:
                      'Equipo de Generación Distribuida de Tecnología Solar Fotovoltaica conectado a la Red de Distribución.',
                    style: { bold: true, fontSize: 13 },
                    margin: [0, 5, 0, 5]
                  },
                  {
                    text: 'Introducción',
                    style: 'subtitulo'
                  },
                  {
                    text:
                      'El Calculador Solar es una herramienta que le permite a un usuario  estimar  cuánta energía podría generar y cuánto dinero podría ahorrar anualmente mediante la instalación de un Equipo de Generación Distribuida de tecnología Solar Fotovoltaica conectado a la red en su hogar, comercio o industria, conforme con la Ley Nacional 27.424 – “Régimen de Fomento a la Generación Distribuida de Energía Renovable Integrada a la Red Eléctrica Pública”.',
                    alignment: 'justify'
                  },
                  {
                    text: 'Valores Ingresados en la simulación:',
                    style: 'subtitulo',
                    margin: [0, 20, 0, 0]
                  },
                  {
                    table: {
                      headerRows: 1,
                      widths: ['*', '*'],
                      body: [
                        [
                          {
                            text: 'Provincia',
                            style: { bold: true },
                            border: [false, false, false, false]
                          },
                          {
                            text: 'Tarifa [$/kWh]',
                            style: { bold: true },
                            border: [false, false, false, false]
                          }
                        ],
                        [
                          {
                            text: this.provinciaSeleccionadaNombre,
                            border: [false, false, false, false]
                          },
                          {
                            text: this.form.tarifa,
                            border: [false, false, false, false]
                          }
                        ]
                      ]
                    },
                    layout: 'noBorders',
                    margin: [0, 20, 0, 20]
                  },
                  {
                    text: 'Consumos [kWh/mes]',
                    style: { bold: true }
                  },
                  {
                    margin: [0, 10, 0, 0],
                    table: {
                      widths: [
                        '*',
                        '*',
                        '*',
                        '*',
                        '*',
                        '*',
                        '*',
                        '*',
                        '*',
                        '*',
                        '*',
                        '*'
                      ],
                      body: [
                        [
                          { text: 'Ene', style: { bold: true } },
                          { text: 'Feb', style: { bold: true } },
                          { text: 'Mar', style: { bold: true } },
                          { text: 'Abr', style: { bold: true } },
                          { text: 'May', style: { bold: true } },
                          { text: 'Jun', style: { bold: true } },
                          { text: 'Jul', style: { bold: true } },
                          { text: 'Ago', style: { bold: true } },
                          { text: 'Sep', style: { bold: true } },
                          { text: 'Oct', style: { bold: true } },
                          { text: 'Nov', style: { bold: true } },
                          { text: 'Dic', style: { bold: true } }
                        ],
                        [
                          this.form.consumos.enero,
                          this.form.consumos.febrero,
                          this.form.consumos.marzo,
                          this.form.consumos.abril,
                          this.form.consumos.mayo,
                          this.form.consumos.junio,
                          this.form.consumos.julio,
                          this.form.consumos.agosto,
                          this.form.consumos.septiembre,
                          this.form.consumos.octubre,
                          this.form.consumos.noviembre,
                          this.form.consumos.diciembre
                        ]
                      ]
                    }
                  },
                  {
                    text: 'Información de los Paneles',
                    margin: [0, 20, 0, 10],
                    style: { bold: true }
                  },
                  {
                    table: {
                      widths: ['*', '*', '*', '*'],
                      body: [
                        [
                          {
                            text: 'Potencia del panel [W]',
                            style: { bold: true }
                          },
                          {
                            text: 'Cantidad [u]',
                            style: { bold: true }
                          },
                          {
                            text: 'Superficie [m2]',
                            style: { bold: true }
                          },
                          {
                            text: 'Potencia a Instalar [kW]',
                            style: { bold: true }
                          }
                        ],
                        [
                          {
                            text: this.form.potenciaPanel
                          },
                          {
                            text: this.form.paneles
                          },
                          {
                            text: this.superficie
                          },
                          {
                            text: this.potenciaInstalar
                          }
                        ]
                      ]
                    }
                  },
                  {
                    margin: [0, 10, 0, 10],
                    table: {
                      widths: ['*', '*', '*'],
                      body: [
                        [
                          {
                            text: 'Autoconsumo [%]',
                            style: { bold: true }
                          },
                          {
                            text: 'Orientación [°]',
                            style: { bold: true }
                          },
                          {
                            text: 'Inclinación [°]',
                            style: { bold: true }
                          }
                        ],
                        [
                          {
                            text: this.form.autoconsumo
                          },
                          {
                            text: this.form.acimut
                          },
                          {
                            text: this.form.inclinacion
                          }
                        ]
                      ]
                    }
                  },
                  {
                    text: [
                      { text: 'Autoconsumo: ', bold: true },
                      'es la fracción de energía efectivamente consumida dentro de su hogar, comercio o industria, respecto al total de la energía que generan los paneles solares conectados. Los paneles solares generan energía eléctrica durante las horas de sol (diurnas), si Ud. se encuentra consumiendo energía durante dichas horas, mayor será el porcentaje de Autoconsumo.'
                    ],
                    margin: [0, 0, 0, 5],
                    alignment: 'justify',
                    pageBreak: 'before'
                  },
                  {
                    text:
                      'A modo de referencia, los porcentajes de autoconsumo promedio según el tipo de usuario son: Residencial (30/40%), Comercial (50/60%) e industrial (60/70%).',
                    alignment: 'justify',
                    margin: [0, 0, 0, 5]
                  },
                  {
                    text: [
                      { text: 'Inyección: ', bold: true },
                      'En caso de existir energía restante que no fue autoconsumida (excedentes), la misma será inyectada a la red y vendida al distribuidor.'
                    ],
                    alignment: 'justify',
                    margin: [0, 0, 0, 5]
                  },
                  {
                    text: [
                      {
                        text: 'Orientación de los paneles solares (Acimut α): ',
                        bold: true
                      },
                      'es el ángulo de desviación respecto del norte geográfico. Siendo el Norte: 0°, Este: 90°, Sur: 180° y Oeste: 270°. Dado que los paneles fotovoltaicos son más productivos cuando los rayos del sol son perpendiculares a la superficie de los mismos, la orientación optima se obtiene cuando se los direcciona directamente hacia el NORTE (ángulo acimutal = 0°).'
                    ],
                    alignment: 'justify',
                    margin: [0, 0, 0, 5]
                  },
                  {
                    image: imagenOrientacion,
                    fit: [500, 400],
                    alignment: 'center',
                    margin: [0, 20, 0, 20]
                  },
                  {
                    text: [
                      {
                        text: 'Inclinación de los Paneles Solares (β): ',
                        bold: true
                      },
                      'es el ángulo que se forma respecto de la horizontal. Siendo 90° en el caso de que se encuentre perpendicular a la horizontal. La inclinación óptima para la máxima producción anual de energía, corresponde a la latitud del lugar donde se instalen.'
                    ],
                    alignment: 'justify',
                    margin: [0, 0, 0, 5]
                  },
                  {
                    type: 'square',
                    ul: [
                      'Inclinación Óptima:  se ve influenciada esencialmente por dos factores:',
                      {
                        type: 'circle',
                        ul: [
                          {
                            text:
                              'La latitud del lugar geográfico donde queramos instalarlos: Si la aplicación pretende maximizar la producción de energía anual, corresponde un valor de inclinación igual a la latitud del lugar.',
                            alignment: 'justify'
                          },
                          {
                            text:
                              'La época del año en que necesitamos tener más energía: Para lograr mayor producción energética durante el periodo invernal, se sugiere inclinar los paneles al valor de la Latitud +10/15°. Por el contrario, si la intención es lograr mayor producción energética durante la estación estival, se sugiere inclinar los paneles al valor de la Latitud -10°.',
                            alignment: 'justify'
                          }
                        ]
                      }
                    ]
                  },
                  {
                    image: imagenInclinacion,
                    fit: [500, 400],
                    alignment: 'center',
                    margin: [0, 20, 0, 20]
                  },
                  {
                    text: 'Gráfico N° 1',
                    style: { bold: true },
                    pageBreak: 'before'
                  },
                  {
                    image: grafico1,
                    width: 550,
                    // fit: [550, 550],
                    alignment: 'center',
                    margin: [0, 10, 0, 0]
                  },
                  {
                    margin: [0, 20, 0, 10],
                    columns: [
                      {
                        table: {
                          widths: ['*', 'auto', 'auto'],
                          body: [
                            [
                              {
                                text: 'Consumo de la Red sin Paneles Solares'
                              },
                              {
                                text: this.consumoAnualSinPaneles
                              },
                              {
                                text: '[kWh/año]'
                              }
                            ],
                            [
                              {
                                text: 'Generación total anual (Paneles Solares)'
                              },
                              {
                                text: this.generacionAnualPaneles.toFixed(0),
                                noWrap: true
                              },
                              {
                                text: '[kWh/año]',
                                noWrap: true
                              }
                            ],
                            [
                              {
                                text: 'Ahorro por Autoconsumo anual'
                              },
                              {
                                text: this.ahorroAnualAutoconsumo.toFixed(0),
                                noWrap: true
                              },
                              {
                                text: '[kWh/año]',
                                noWrap: true
                              }
                            ],
                            [
                              {
                                text: 'Ahorro por Autoconsumo porcentual anual'
                              },
                              {
                                text: this.ahorroAnualAutoconsumoPorcentaje,
                                noWrap: true
                              },
                              {
                                text: '[%]',
                                noWrap: true
                              }
                            ]
                          ]
                        }
                      },
                      {
                        text: [
                          {
                            text:
                              'Ahorro de Emisiones de Gases de Efecto Invernadero\n',
                            style: { bold: true }
                          },
                          {
                            text: this.emisiones,
                            fontSize: 16,
                            style: { bold: true, color: 'green' }
                          },
                          '\nToneladas de CO 2 equivalentes'
                        ],
                        alignment: 'center'
                      }
                    ]
                  },
                  {
                    text: [
                      'En el ',
                      {
                        text: 'gráfico N° 1',
                        bold: true
                      },
                      '- "Generación de los Paneles y Consumo de la Red Mensuales" podemos observar lo siguiente:'
                    ],
                    alignment: 'justify',
                    margin: [0, 15, 0, 10]
                  },
                  {
                    ul: [
                      {
                        text: `Las barras representan la generación mensual de los paneles solares instalados en función a la orientación (acimut α): ${
                          this.form.acimut
                        }° y la inclinación (β): ${
                          this.form.inclinacion
                        }° que seleccionó`,
                        alignment: 'justify'
                      },
                      {
                        text:
                          'La línea continua (---), representa el consumo energético mensual de la red que usted ingresó como dato. En caso de no haber completado algún mes, se tomará un promedio de todos los valores ingresados para los meses faltantes. Estos valores de consumo corresponden a los que figuran en su factura de electricidad.',
                        alignment: 'justify'
                      },
                      {
                        text:
                          'La línea punteada (- - -), representa el nuevo consumo energético mensual de la red, luego de haber instalado los paneles solares.',
                        alignment: 'justify'
                      },
                      {
                        type: 'square',
                        ul: [
                          'Fórmulas utilizadas:',
                          {
                            type: 'circle',
                            ul: [
                              {
                                text:
                                  'Energía Autoconsumida [kWh/mes] = Generación total mensual de los paneles solares [kWh/mes] * Porcentaje de autoconsumo [%]',
                                alignment: 'justify'
                              },
                              {
                                text:
                                  'Ahorro de consumo energético mensual de la red [%] = Energía Autoconsumida [kWh/mes] / Consumo energético mensual de la red sin Paneles Solares [kWh/mes].',
                                alignment: 'justify'
                              },
                              {
                                text:
                                  'Consumo energético mensual de la red con Paneles Solares [kWh/mes]  = Consumo energético mensual de la red sin Paneles Solares [kWh/mes] * (1- Ahorro de consumo energético mensual de la red [%])',
                                alignment: 'justify'
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    text:
                      'Datos de Consumo, Generación, Autoconsumo e Inyección de energía mensual',
                    margin: [0, 20, 0, 10],
                    style: { bold: true },
                    pageBreak: 'before'
                  },
                  {
                    text:
                      'La siguiente tabla presenta un resumen mensual del consumo eléctrico, la generación eléctrica producida por la instalación fotovoltaica, el autoconsumo y la inyección de excedentes de la energía generada. Los valores se encuentran expresados en kWh:'
                  },
                  {
                    alignment: 'center',
                    margin: [0, 10, 0, 0],
                    table: {
                      body: [
                        [
                          {
                            text: 'Mes',
                            style: { bold: true },
                            alignment: 'center'
                          },
                          {
                            text: 'Consumo Energético de la Red [kWh]',
                            style: { bold: true }
                          },
                          {
                            text: 'Generación Eléctrica [kWh]',
                            style: { bold: true }
                          },
                          {
                            text:
                              'Energía Autoconsumida de la Generación [kWh]',
                            style: { bold: true }
                          },
                          {
                            text:
                              'Excedente de Energía generada (Inyectada) [kWh]',
                            style: { bold: true }
                          }
                        ],
                        [
                          { text: 'Enero', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[0]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[0].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[0].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[0].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Febrero', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[1]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[1].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[1].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[1].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Marzo', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[2]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[2].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[2].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[2].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Abril', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[3]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[3].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[3].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[3].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Mayo', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[4]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[4].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[4].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[4].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Junio', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[5]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[5].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[5].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[5].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Julio', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[6]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[6].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[6].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[6].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Agosto', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[7]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[7].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[7].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[7].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Septiembre', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[8]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[8].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[8].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[8].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Octubre', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[9]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[9].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[9].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[9].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Noviembre', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[10]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[10].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[10].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[10].toFixed(
                              1
                            )
                          }
                        ],
                        [
                          { text: 'Diciembre', alignment: 'left' },
                          {
                            text: this.$store.getters.currentData
                              .variacionFacturacion.seriesMensuales
                              .consumoRedSinFV[11]
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.generacionMensualFV[11].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaAutoconsumida[11].toFixed(
                              1
                            )
                          },
                          {
                            text: this.$store.getters.currentData.variacionFacturacion.seriesMensuales.energiaInyectada[11].toFixed(
                              1
                            )
                          }
                        ]
                      ]
                    }
                  },
                  {
                    text: 'Gráfico N° 2',
                    style: { bold: true },
                    pageBreak: 'before'
                  },
                  {
                    image: grafico2,
                    width: 550,
                    // fit: [550, 550],
                    alignment: 'center',
                    margin: [0, 10, 0, 0]
                  },
                  {
                    text: [
                      'En el ',
                      {
                        text: 'gráfico N° 2',
                        bold: true
                      },
                      '- "Variación en la facturación por ahorro en el consumo" podemos observar lo siguiente:'
                    ],
                    alignment: 'justify',
                    margin: [0, 15, 0, 5]
                  },
                  {
                    ul: [
                      {
                        text:
                          'La línea continua (---), representa el Saldo Mensual [$/mes] respecto del Cargo Variable sin bonificación [$/kWh] que usted pagará por el consumo energético mensual de la red en su factura. El cargo variable de no encontrarlo en su factura, podrá remitirse al Cuadro Tarifario de su Distribuidora de Electricidad.',
                        alignment: 'justify'
                      },
                      {
                        text:
                          'La línea punteada (- - -), representa el Nuevo Saldo Mensual [$/mes] respecto del Cargo Variable sin bonificación [$/kWh] que usted pagará por el Consumo energético mensual de la red con  el o los paneles solares ya instalados. En caso de que este valor de negativo, significa que usted tiene crédito a favor. En caso de ser positivo, significa que usted deberá pagar.',
                        alignment: 'justify'
                      },
                      {
                        type: 'square',
                        ul: [
                          'Fórmulas utilizadas:',
                          {
                            type: 'circle',
                            ul: [
                              {
                                text:
                                  'Energía Autoconsumida [kWh/mes] = Generación total mensual de los paneles solares [kWh/mes] * Porcentaje de autoconsumo [%]',
                                alignment: 'justify'
                              },
                              {
                                text:
                                  'Saldo Mensual [$/mes] =  Consumo energético mensual de la red sin Paneles Solares [kWh/mes] *  Valor del Cargo Variable [$/kWh].',
                                alignment: 'justify'
                              },
                              {
                                text:
                                  'Nuevo Saldo Mensual [$/mes] = (Consumo energético mensual de la red con paneles solares [kWh/mes] * Valor del Cargo Variable [$/kWh]) – Inyección mensual [$/mes].',
                                alignment: 'justify'
                              },
                              {
                                text:
                                  'Inyección mensual [$/mes] = Energía Inyectada [kWh/mes] * Precio estabilizado de energía y transporte que deben pagar los distribuidores en el Mercado Eléctrico Mayorista (MEM) [$/kWh].',
                                alignment: 'justify'
                              },
                              {
                                text:
                                  'Energía Inyectada [kWh/mes] = Generación total mensual del o los paneles solares [kWh/mes] * (1 – Porcentaje de Autoconsumo [%]).',
                                alignment: 'justify'
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    text:
                      '* Los resultados arrojados por el presente reporte son estimativos. Los mismos pueden presentar variaciones propias del sistema, de los datos aportados, de las revisiones tarifarias y/o de las fluctuaciones climáticas, no asumiendo responsabilidad ni obligación por los resultados obtenido.',
                    style: { italics: true, fontSize: 10 },
                    alignment: 'justify',
                    margin: [0, 80, 0, 0],
                    pageBreak: 'after'
                  }
                ]
              }
              resolve(docDefinition)
            })
          })
        }, 500)
      })
    },
    imprimirPDF() {
      this.generarPDF().then(dd => {
        pdfMake.vfs = pdfFonts.pdfMake.vfs
        pdfMake.createPdf(dd).print()
      })
    },
    descargarPDF() {
      this.generarPDF().then(dd => {
        pdfMake.vfs = pdfFonts.pdfMake.vfs
        pdfMake.createPdf(dd).download('calculador-solar.pdf')
      })
    }
  }
}
</script>
<style>
#stepper_header {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-stepper__step--active {
  background: rgba(0, 0, 0, 0.06);
  margin-left: 15px;
  margin-right: 15px;
}

.v-stepper__step--active:first-of-type {
  background: rgba(0, 0, 0, 0.06);
  margin-left: 0px;
  margin-right: 15px;
}
.v-stepper__step--active:last-of-type {
  background: rgba(0, 0, 0, 0.06);
  margin-left: 15px;
  margin-right: 0px;
}

.v-stepper__items {
  padding-top: 80px;
}

#mapaArgentina path:not(#caba-sample):hover {
  fill: #75c2e7;
  cursor: pointer;
}

#mapaArgentina {
  display: flex;
  position: relative;
  width: 100%;
  height: calc(100vh - 200px); /* aspect ratio */
  vertical-align: top;
  overflow: hidden;
}

#mapaArgentina svg {
  width: 100%;
  height: 100%;
}

#c-a-b-a {
  transform: scale(5) translate(-127px, -173px);
}

@media print {
  @page {
    size: A4 portrait;
  }
  html,
  body {
    height: 297mm;
    width: 210mm;
    overflow: hidden;
  }
  .v-toolbar.v-toolbar--fixed {
    display: none !important;
  }
  .v-stepper__header {
    display: none !important;
  }
  .v-stepper__content:not(:first-of-type) {
    display: block !important;
    /* page-break-after: always; */
  }
  .v-content {
    padding: 0 !important;
    margin: 0 !important;
  }
  #stepper {
    padding: 0 !important;
  }
  .no-print {
    display: none !important;
  }
  .v-card,
  .v-stepper {
    box-shadow: none !important;
  }

  .v-form > .layout.row.wrap > .flex {
    flex-basis: 25%;
    max-width: 25%;
    display: inline-block;
  }
  .flex.pl-3.pr-3.xs6.sm4.md3 {
    flex-basis: 16.666666666666664% !important;
    max-width: 16.666666666666664% !important;
  }
  .v-stepper__content {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .v-input {
    margin-top: 0 !important;
  }
  .v-input input {
    padding: 4px 0 !important;
  }
  .v-footer .layout {
    margin: 0 !important;
  }
  .v-footer {
    padding-bottom: 2cm !important;
    padding-top: 0px !important;
    margin-top: 0 !important;
  }
  #ahorro_emisiones {
    margin: 0;
    padding: 5px;
    width: 100%;
    border: solid 1px #ddd;
  }

  #ahorro_emisiones *:not(sub) {
    border: none !important;
    display: block !important;
    padding: 0 !important;
    padding-left: 5px !important;
    font-size: 14px !important;
    margin: 0 !important;
    line-height: 16px !important;
    text-align: center !important;
  }
  #ahorro_emisiones .display-3 {
    font-size: 16px;
  }
  hr {
    display: none !important;
  }
  .highcharts-title tspan {
    font-size: 12px !important;
  }
  .highcharts-legend-item tspan {
    font-size: 10px !important;
  }
  .v-text-field .v-label,
  .v-text-field .v-label.v-label--active {
    max-width: calc(100% + 50px) !important;
    width: calc(100% + 50px) !important;
    text-overflow: initial;
  }
}
</style>
